import {ControlsHeight} from '@jetbrains/ring-ui-built/components/global/controls-height'
import Theme, {ThemeProvider} from '@jetbrains/ring-ui-built/components/global/theme'
import type {IconType} from '@jetbrains/ring-ui-built/components/icon/icon'
import {SvgIcon} from '@jetbrains/teamcity-ui/dist/components'
import classNames from 'classnames'

import {useDarkOrLightTheme} from '../../../hooks/theme/useDarkOrLightTheme'
import type {RouterButtonProps} from '../RouterLink/RouterLink'
import {RouterButton} from '../RouterLink/RouterLink'

import styles from './ToggleLink.module.css'

type Props = RouterButtonProps & {
  icon: IconType | string
  label: string
  checked: boolean
  disabled?: boolean
  switcherClassName?: string
}

export default function ToggleLink({
  icon,
  label,
  checked,
  disabled,
  className,
  switcherClassName,
  ...props
}: Props) {
  const theme = useDarkOrLightTheme()
  const switcher = (
    <ThemeProvider theme={disabled ? theme : Theme.LIGHT}>
      <span className={styles.switcher}>
        <SvgIcon icon={icon} className={switcherClassName} />
      </span>
    </ThemeProvider>
  )
  const labelElement = <span className={styles.label}>{label}</span>

  return (
    <RouterButton
      data-test="toggle-link"
      className={classNames(styles.toggle, className, {
        [styles.disabled]: disabled,
        [styles.checked]: checked,
        [styles.loading]: props.loader,
      })}
      primary={checked}
      height={ControlsHeight.M}
      aria-label={label}
      disabled={disabled}
      {...props}
    >
      <span className={styles.content}>
        {checked ? (
          <>
            {labelElement}
            {switcher}
          </>
        ) : (
          <>
            {switcher}
            {labelElement}
          </>
        )}
      </span>
    </RouterButton>
  )
}
